import React from "react";
import { Table } from "antd";

const Datatable = (props) => {

  const { rowKey, loading, columns, dataSource, totalCount, pageSize, currentPage, onChange, isPagination, size, showHeader, expandable } = props;

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <div className="px-3 border border-[#DFE5F1] rounded-md ">Back</div>;
    }
    if (type === "next") {
      return <div className="px-3 border border-[#DFE5F1] rounded-md ">Next</div>;
    }
    return originalElement;
  };

  const pagination = {
    total: totalCount,
    pageSize: pageSize,
    showSizeChanger: true,
    current: currentPage,
    onChange: (page, pageSize) => onChange(page, pageSize),
    itemRender,
  }

  return (
    <Table
      loading={loading}
      className="table-striped table datanew dataTable"
      size={size}
      rowKey={rowKey}
      showHeader={showHeader}
      columns={columns}
      dataSource={dataSource}
      expandable={expandable}
      pagination={isPagination == false ? isPagination : pagination}
    />
  );
};

export default Datatable;
